export const ACCENT = "#5D8FC4";

export const LOGO_URL = "/assets/logo.jpg";
export const OSCAR_URL = "/assets/oscar.jpg";
export const BG_URL = "/assets/blueprint.jpg";
export const HOUSE_BG_URL = "/assets/house.jpg";
export const VA_BG_URL = "/assets/va.jpg";

export const HOST = {
  name: "Oscar Tobar",
  company: "Great Western Funding",
  nmls: "NMLS# 667612",
  phone: "(818) 231-0061",
  states: "California & Florida",
  initials: "OT",
};

export const WEBINAR = {
  title: "VA PURCHASING POWER",
  date: "SEPTEMBER 10TH, 2026 AT 6:00 PM EST",
  duration: "45 MINUTES",
  modules: 5,
  eyebrow: "FREE 45-MINUTE LIVE BRIEFING FOR FLORIDA VETERANS & ACTIVE DUTY",
};

export const BONUSES = [
  "Free Live Webinar Access",
  "Live VA Entitlement & Purchasing Power Calculation",
  "Document & Timeline Checklist",
  "Credit Guidance Before Any Hard Pull",
  "Direct Follow-Up With Oscar — No Call Center Hand-Offs",
];

export const FALSE_BELIEFS = [
  "\u201CYou need a down payment saved up before you can even start looking.\u201D",
  "\u201CEvery lender treats VA loans the same, so it doesn't matter who you call first.\u201D",
  "\u201CYou should wait until your finances are 'more stable' before finding out what you qualify for.\u201D",
];

export const AUDIENCE_CARDS = [
  { icon: "Medal", text: "Veterans Exploring Homeownership Options" },
  { icon: "Shield", text: "Active Duty Service Members Preparing to Buy" },
  { icon: "Home", text: "Guard & Reserve Members Who Qualify for VA Benefits" },
  { icon: "Heart", text: "Surviving Spouses with VA Loan Eligibility" },
  { icon: "HelpCircle", text: "Anyone Who's Been Told They Need a Down Payment First" },
];

export const MODULES = [
  { title: "UNDERSTAND YOUR BENEFIT", body: "What VA entitlement actually covers and how $0-down purchasing power is calculated." },
  { title: "KNOW WHAT TO PREPARE", body: "Documents and planning questions for the process — before any hard credit pull." },
  { title: "EXPLORE VA LOAN CONSIDERATIONS", body: "Eligibility, entitlement, funding fee, appraisal, and how VA guidelines differ from conventional." },
  { title: "AVOID COMMON MISSTEPS", body: "Why rate-shopping across multiple lenders costs veterans money and time." },
  { title: "LEAVE WITH NEXT STEPS", body: "Your personal purchasing power number + a clear next step, no obligation." },
];

export const ROADMAP = [
  { step: "01", name: "RESERVE", desc: "Lock in your free seat. Takes 30 seconds — no documents, no credit pull." },
  { step: "02", name: "WATCH", desc: "Join the live 45-minute briefing. Bring your questions for the live Q&A." },
  { step: "03", name: "PREPARE", desc: "Use the document & timeline checklist to get organized on your schedule." },
  { step: "04", name: "DECIDE", desc: "Know your number, know your options — and decide your next move on your terms." },
];

export const TRANSFORMS = [
  "You'll know your exact $0-down purchasing power before you talk to a single lender",
  "You'll understand which eligibility factors actually matter — and which ones don't",
  "You'll have a clear next step and a direct line to one broker, not a shared-lead call center",
];

export const TAKEAWAYS = [
  { icon: "Map", title: "Clearer View", desc: "A plain-English picture of how your VA benefit translates into real purchasing power." },
  { icon: "CheckSquare", title: "Preparation Checklist", desc: "The exact documents and timeline steps to have ready — before anyone pulls credit." },
  { icon: "MessageSquare", title: "Questions to Ask", desc: "The questions that separate a VA-fluent lender from one who treats you like a conventional buyer." },
  { icon: "ClipboardList", title: "Optional Next Step", desc: "A no-obligation path to your personal purchasing power number, if and when you want it." },
];

export const FAQS = [
  { q: "Is the webinar free?", a: "Yes — completely free. This is a 45-minute educational briefing on VA home loans and $0-down purchasing power. There is no cost to attend, no upsell at the end, and nothing to buy." },
  { q: "Is this a loan application?", a: "No. Attending is not a loan application and does not start one. This is an educational session about how VA entitlement and purchasing power work. Any application would be a separate, deliberate step you'd choose to take later — or not at all." },
  { q: "Will attending affect my credit?", a: "No. There is no hard credit pull required to attend or register. In fact, one of the modules covers credit guidance before any hard pull, so you know exactly where you stand before anyone runs your credit." },
  { q: "Who is this webinar for?", a: "Veterans, active duty service members, Guard & Reserve members, and surviving spouses with VA loan eligibility — especially anyone who has been told they need a down payment first, or has been quoted like a conventional buyer." },
  { q: "What will be covered?", a: "Five modules over 45 minutes: understanding your VA benefit, what to prepare, VA loan considerations (entitlement, funding fee, appraisal), common missteps like rate-shopping across multiple lenders, and your clear next steps — plus live Q&A." },
  { q: "Is it live or on demand?", a: "It's a live session — September 10th, 2026 at 6:00 PM EST — with live Q&A, so you can ask questions about your specific situation. Register even if you're unsure you can attend; registrants receive the follow-up materials." },
  { q: "What happens after I register?", a: "You'll receive a confirmation with the session details, followed by a reminder before we go live. That's it — no sales calls, no call-center hand-offs, and no obligation of any kind." },
  { q: "Do I have to speak with a loan officer?", a: "No. Attending carries zero obligation. If you want a personal VA purchasing power calculation afterward, that option is available directly with Oscar — but it's entirely optional and entirely on your timeline." },
];

export const CONSENT_TEXT = "By checking this box, I consent to receive SMS messages from Great Western Funding regarding my inquiry, appointments, mortgage application, educational events, service updates, follow-up communications, and promotional offers. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not a condition of purchasing any property, product, or service. View our Privacy Policy and Terms and Conditions.";

export const COMPLIANCE = "This is an educational webinar. Attendance does not constitute a loan application. No hard credit pull required to attend. Not affiliated with or endorsed by the Dept. of Veterans Affairs or any government agency. Rates, terms, and approval are not guaranteed and are subject to underwriting. Oscar Tobar NMLS# 667612, Great Western Funding NMLS# 2739318. Equal Housing Opportunity.";

export const STATES = ["Florida"];
export const JOURNEYS = ["Just exploring my options", "Buying in 0–3 months", "Buying in 3–6 months", "Buying in 6+ months", "PCS / relocating soon"];

export function captureAttribution() {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || null,
    utm_medium: p.get("utm_medium") || null,
    utm_campaign: p.get("utm_campaign") || null,
    utm_content: p.get("utm_content") || null,
    utm_term: p.get("utm_term") || null,
    fbclid: p.get("fbclid") || null,
    gclid: p.get("gclid") || null,
    pageUrl: window.location.href,
    referrer: document.referrer || null,
    timestamp: new Date().toISOString(),
  };
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el.scrollIntoView({ behavior: "smooth" });
}
